// /welcome?step=… (the guided first run), plus Google's ?connected= / ?error= after connecting.
import { STEPS, type StepId } from "./steps";

export interface WelcomeSearch {
  step?: StepId | undefined;
  /** Google's connect flow comes back with ?connected=<email> or ?error=<code>. */
  connected?: string | undefined;
  error?: string | undefined;
}

export function parseWelcomeSearch(raw: Record<string, unknown>): WelcomeSearch {
  const pick = (v: unknown) =>
    typeof v === "string" && v.trim() ? v.trim().slice(0, 200) : undefined;
  const step = pick(raw.step);
  return {
    step: STEPS.some((s) => s.id === step) ? (step as StepId) : undefined,
    connected: pick(raw.connected),
    error: pick(raw.error),
  };
}
